<template>
  <div>
    <jet-dialog-modal :show="openModal" @close="closeModal">
      <template #title> ยืนยันการลบโดเมน </template>

      <template #content>
        คุณต้องการจะลบโดเมน {{ project.domain_name }} ใช่หรือไม่ <span class="text-red-600">Cookie Banner จะหยุดแสดงบนเว็บไซต์ของคุณ และข้อมูลสถิติต่าง ๆ ของโดเมนนี้ที่เก็บไว้จะถูกลบไปด้วยและไม่สามารถกู้คืนได้</span>
        <div class="mt-4">
          <jet-label for="confirm_text" value="กรุณาพิมพ์คำว่า DELETE เพื่อยืนยัน*" />
          <jet-input
            type="text"
            class="mt-1 block w-3/4"
            placeholder="DELETE"
            ref="confirm_text"
            v-model="confirmText"
          />
        </div>
      </template>

      <template #footer>
        <jet-secondary-button @click="closeModal">
            ยกเลิก
        </jet-secondary-button>

        <jet-danger-button class="ml-3" @click="deleteProject" :class="{ 'opacity-25': form.processing || confirmText != 'DELETE' }" :disabled="form.processing || confirmText != 'DELETE'">
            ใช่ ยืนยันลบโดเมน
        </jet-danger-button>
      </template>
    </jet-dialog-modal>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import JetActionSection from "@/Jetstream/ActionSection.vue";
import JetDialogModal from "@/Jetstream/DialogModal.vue";
import JetDangerButton from "@/Jetstream/DangerButton.vue";
import JetInput from "@/Jetstream/Input.vue";
import JetLabel from "@/Jetstream/Label.vue";
import JetInputError from "@/Jetstream/InputError.vue";
import JetSecondaryButton from "@/Jetstream/SecondaryButton.vue";

export default defineComponent({
  props: ["openModal", "project"],

  components: {
    JetActionSection,
    JetDangerButton,
    JetDialogModal,
    JetInput,
    JetInputError,
    JetSecondaryButton,
    JetLabel,
  },

  data() {
    return {
      confirmText: "",
      form: this.$inertia.form(),
    };
  },

  methods: {
    deleteProject() {
      this.form.delete(route("projects.destroy", this.project), {
        preserveScroll: false,
        onSuccess: () => this.closeModal(),
        onError: () => this.$refs.confirm_text.focus(),
        onFinish: () => this.form.reset(),
      });
    },

    closeModal() {
      this.confirmText = "";
      this.form.reset();
      this.$emit("close-modal");
    },
  },

  watch: {
    openModal(value) {
      if (value) //open
        setTimeout(() => this.$refs.confirm_text.focus(), 250);
    }
  },
});
</script>
